<template>
  <section class="border-t border-default/60 bg-default">
    <UContainer class="py-12 sm:py-14">
      <div class="mx-auto max-w-md space-y-4">
        <h2 class="text-center text-xl font-semibold">
          {{ title || item?.title || 'لیست انتظار' }}
        </h2>
        <p
          v-if="subtitle || item?.description"
          class="text-center text-sm text-muted"
        >
          {{ subtitle || item?.description }}
        </p>
        <form
          class="space-y-3"
          @submit.prevent="submit"
        >
          <UFormField label="نام">
            <UInput
              v-model="name"
              :disabled="builderPreview"
            />
          </UFormField>
          <AuthPhoneInput v-model="phone" />
          <UButton
            type="submit"
            block
            class="min-h-11"
            :loading="saving"
            :disabled="!canSubmit"
          >
            عضویت در لیست
          </UButton>
        </form>
        <p
          v-if="done"
          class="text-center text-sm text-primary"
        >
          در لیست انتظار ثبت شدید.
        </p>
        <p
          v-if="error"
          class="text-center text-sm text-error"
        >
          {{ error }}
        </p>
      </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import AuthPhoneInput from '~/components/auth/PhoneInput.vue'
import { isCompleteIrMobile } from '~/utils/phone'
import { apiErrorMessage } from '~/utils/apiError'

const props = defineProps<{
  title?: string
  subtitle?: string
  waitlistId?: string
  builderPreview?: boolean
}>()

const name = ref('')
const phone = ref('')
const saving = ref(false)
const done = ref(false)
const error = ref('')
const item = ref<{ title: string; description: string } | null>(null)
const canSubmit = computed(() => !props.builderPreview && !!props.waitlistId && isCompleteIrMobile(phone.value) && name.value.trim().length >= 2)

if (import.meta.client && props.waitlistId && !props.builderPreview) {
  $fetch<{ item: NonNullable<typeof item.value> }>(`/api/leads/waitlists/${props.waitlistId}`)
    .then((res) => { item.value = res.item })
    .catch(() => {})
}

async function submit() {
  if (!canSubmit.value || !props.waitlistId) return
  saving.value = true
  error.value = ''
  try {
    await $fetch(`/api/leads/waitlists/${props.waitlistId}/register`, {
      method: 'POST',
      body: { name: name.value, phone: phone.value },
    })
    done.value = true
  }
  catch (err) {
    error.value = apiErrorMessage(err, 'ثبت ناموفق بود')
  }
  finally {
    saving.value = false
  }
}
</script>
